export default __webpack_public_path__ + "media/fed_ramp.7ab2e7d5.png";